import {Tractor} from 'shared';
import moment from 'moment';

export class FlowMeterRequest {
  isToday: boolean;
  from: Date;
  to: Date;
  tractor?: Tractor;
  currentFilter = 2;

  constructor() {
    this.from = moment().startOf('day').toDate();
    this.to = moment().endOf('day').toDate();
    this.isToday = true;
  }
}
